import React, { RefObject, useState } from "react";
import { ProductCutDown } from "../ProductDetailPageResult";
import ProductCutDownIncludeCasterHeight from "./ProductCutDownIncludeCasterHeight";
import ProductCutDownSelectCasters from "./ProductCutDownSelectCasters";
import ProductCutDownSelectHeight from "./ProductCutDownSelectHeight";
import ProductCutDownTable from "./ProductCutDownTable";

interface Props {
  productCutDown: ProductCutDown;
  productItemNumber: string;
  productPrice: number;
  form: RefObject<HTMLFormElement>;
  hasQuantityDiscounts: boolean;
  quantityDiscountPrice?: number;
  quantityDiscountQty?: number;
  onSubmit: (form: RefObject<HTMLFormElement>) => boolean;
}

const ProductCutDownForm = ({
  productCutDown,
  productItemNumber,
  productPrice,
  form,
  hasQuantityDiscounts,
  quantityDiscountPrice,
  quantityDiscountQty,
  onSubmit,
}: Props) => {
  const [addCasters, setAddCasters] = useState<boolean>(false);

  const [quantity, setQuantity] = useState<number>(1);

  const [includeCasterInHeight, setIncludeCasterInHeight] =
    useState<boolean>(false);

  const [selectedHeight, setSelectedHeight] = useState<string>(
    String(productCutDown.maximumHeight),
  );

  return (
    <form
      name="cutDownOrder"
      action="/viewcart.cfm"
      method="post"
      ref={form}
      onSubmit={(event) => {
        if (!onSubmit(form)) {
          event.preventDefault();
        }
      }}
    >
      <input
        type="hidden"
        name="cutDownPrice"
        value={productCutDown.cutDownPrice}
      />
      <input type="hidden" name="item_number_1" value={productItemNumber} />
      <input type="hidden" name="item_number_2" value="M1T" />
      <input
        type="hidden"
        name="description_2"
        value={
          `${productItemNumber} ${addCasters ? "" : "0xCasters"}` +
          `Cut Down Height: ${
            includeCasterInHeight
              ? Number(selectedHeight) - productCutDown.casterHeight
              : Number(selectedHeight)
          }in ` +
          `${
            addCasters
              ? `Height With Casters: ${
                  includeCasterInHeight
                    ? Number(selectedHeight)
                    : Number(selectedHeight) + productCutDown.casterHeight
                }in`
              : ""
          }`
        }
      />
      <input type="hidden" name="from" value="add" />
      {addCasters && (
        <input
          type="hidden"
          name="item_number_3"
          value={productCutDown.casterItemNumber}
        />
      )}
      <ProductCutDownSelectHeight
        selectedHeight={selectedHeight}
        setSelectedHeight={setSelectedHeight}
        maximumHeight={productCutDown.maximumHeight}
        minimumHeight={productCutDown.minimumHeight}
      />
      {!productCutDown.hasCasters &&
        productCutDown.casterItemNumber?.length > 0 && (
          <ProductCutDownSelectCasters setAddCasters={setAddCasters} />
        )}
      {addCasters && (
        <ProductCutDownIncludeCasterHeight
          setIncludeCasterInHeight={setIncludeCasterInHeight}
        />
      )}
      <ProductCutDownTable
        addCasters={addCasters}
        casterHeight={productCutDown.casterHeight}
        selectedHeight={selectedHeight}
        includeCasterInHeight={includeCasterInHeight}
        quantity={quantity}
        setQuantity={setQuantity}
        cutDownPrice={productCutDown.cutDownPrice}
        casterItemPrice={productCutDown.casterItemPrice}
        numberOfLegs={productCutDown.numberOfLegs}
        productPrice={productPrice}
        hasQuantityDiscounts={hasQuantityDiscounts}
        quantityDiscountPrice={quantityDiscountPrice}
        quantityDiscountQty={quantityDiscountQty}
      />
    </form>
  );
};

export default ProductCutDownForm;
